import React from "react";
import "./AddNew.css";
import Sidebar from "../Sidebar/Sidebar";
import { Link } from "react-router-dom";
import SimpleDropdown from "../SimpleDropdown";
import Brands from "../../Data/Brands";
import Categories from "../../Data/Categories";
import axios from "axios";
import * as backendModule from "../../modules/backendModule";
import Spinner from "../Spinner";

const AddNew = () => {
    const [isAvailable, setIsAvailable] = React.useState(null);
    const [brend, setBrend] = React.useState(null);
    const [category, setCategory] = React.useState(null);
    const [image, setImage] = React.useState(null);
    const [image2, setImage2] = React.useState(null);
    const [error, setError] = React.useState(null);
    const [spinner, setSpinner] = React.useState(null);
    const [message, setMessage] = React.useState(null);
    const nameRef = React.useRef(null);
    const priceRef = React.useRef(null);
    const modelRef = React.useRef(null);
    const descriptionRef = React.useRef(null);

    const handleImageChange = (e) => {
        setImage(e.target.files[0]);
    }
    const handleImageChange2 = (e) => {
        setImage2(e.target.files[0]);
    }

    const createProduct = () => {
        if (
            isAvailable !== null &&
            brend !== null &&
            category !== null &&
            nameRef.current.value !== null &&
            priceRef.current.value !== null &&
            modelRef.current.value !== null &&
            descriptionRef.current.value !== null
        ) {
            setSpinner(true);
        } else {
            return setError('Nedovoljno podataka!');
        }

        const data = new FormData();
        data.append('Name', nameRef.current.value);
        data.append('Model', modelRef.current.value);
        data.append('Price', priceRef.current.value);
        data.append('Description', descriptionRef.current.value);
        data.append('Available', isAvailable.value);
        data.append('Category', category.name);
        data.append('CategoryID', category.value);
        data.append('Brand', brend.name);
        data.append('BrandID', brend.value);

        if (image) {
            data.append('image', image);
        }

        if (image2) {
            data.append('image2', image2);
        }

        axios({
            method: "POST",
            url: `${backendModule.backendURL}/products/addProduct`,
            data: data,
            ...backendModule.axiosConfig,
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            if (res.data.status === "ok") {
                setMessage('Uspješno ste dodali novi proizvod.');
                setError(null);
            } else {
                setError('Unknown error occurred');
                setMessage(null);
            }
        }).catch(() => {
            setError('Unknown error occurred');
            setMessage(null);
        }).finally(() => {
            setSpinner(false);
        });
    }

    return (
        <div className="addNew">
            <Sidebar />
            <div className="addNew__container">
                <div className="addNew__container__modal">
                    <div className="addNew__container__modal__item">
                        <label>Naziv proizvoda</label>
                        <input ref={nameRef} type="text" />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Cijena</label>
                        <input ref={priceRef} type="text" />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Model</label>
                        <input ref={modelRef} type="text" />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Dostupno</label>
                        <SimpleDropdown headTextStyle={{ color: '#1A1A1A' }} headStyle={{ height: '30px', background: 'white', border: '1px solid black', borderRadius: '0px' }} heading='Da li je dostupno' data={[{ name: 'Da', value: true }, { name: 'Ne', value: false }]} setSelected={setIsAvailable} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Brend</label>
                        <SimpleDropdown headTextStyle={{ color: '#1A1A1A' }} headStyle={{ height: '30px', background: 'white', border: '1px solid black', borderRadius: '0px' }} heading='Odaberi brend' data={Brands.map((item) => { return { name: item.Name, value: item.ID } })} setSelected={setBrend} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Kategorija</label>
                        <SimpleDropdown headTextStyle={{ color: '#1A1A1A' }} headStyle={{ height: '30px', background: 'white', border: '1px solid black', borderRadius: '0px' }} heading='Odaberi kategoriju' data={Categories.map((item) => { return { name: item.Name, value: item.ID } })} setSelected={setCategory} />

                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Slika 1</label>
                        <input accept="image/*" type='file' name="image" onChange={handleImageChange} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Slika 2</label>
                        <input accept="image/*" type='file' name="image" onChange={handleImageChange2} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Opis</label>
                        <textarea ref={descriptionRef}></textarea>
                    </div>
                </div>
                <div onClick={() => createProduct()} className="addNew__container__button">
                    {!spinner ? <p>Sačuvaj</p> : <Spinner color='white' style={{ width: '24px', height: '24px', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} />}
                </div>
                {message && <p style={{color: "green", fontSize: "18px", marginTop: "10px"}}>{message}</p>}
                {error && <p style={{color: "#b31414", fontSize: "18px", marginTop: "10px"}}>{error}</p>}
            </div>
        </div>
    );
};

export default AddNew;
